import { useAppSelector } from '@/shared/hooks/useStore';

type SignedInState = { readonly userData: { readonly data: { readonly id?: string } | null } };

const selectSignedInUserId = (state: SignedInState): string | null =>
  state.userData.data?.id ?? null;

export function useSignedInUserId(): string | null {
  return useAppSelector(selectSignedInUserId);
}
